import * as React from 'react';
import { CardCountIndicator } from '../CardCountIndicator/CardCountIndicator';
import { IAttachmentsCountIndicatorProps } from './types';
import { ATTACHMENTS_TOOLTIP } from '../../wording';

export function AttachmentsCountIndicator({
    active,
    attachmentsCount,
    onClick
}: IAttachmentsCountIndicatorProps) {
    return (
        <CardCountIndicator
            active={active}
            icon={'attachment'}
            tooltip={ATTACHMENTS_TOOLTIP}
            onClick={onClick}
        >
            <span>{attachmentsCount}</span>
        </CardCountIndicator>
    );
}
